import React from 'react';
import { useUserProfile } from '../../lib/hooks/useUserProfile';
import { useI18n } from '../../contexts/I18nContext';
import AvatarUpload from './AvatarUpload';
import ProfileForm from './ProfileForm';
import LoadingState from './components/LoadingState';
import ErrorState from './components/ErrorState';
import UserInfoDisplay from './components/UserInfoDisplay';
import './MyProfile.scss';

const MyProfile = () => {
  const { t } = useI18n();
  const {
    currentUser,
    isLoading,
    error,
    updateAvatar,
    updateProfile,
    retryFetch
  } = useUserProfile();

  // Loading state
  if (isLoading) {
    return (
      <div className="my-profile">
        <LoadingState message={t('personalCenter.myProfile.loadingProfile')} />
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="my-profile">
        <ErrorState
          title={t('personalCenter.myProfile.loadingFailed')}
          message={error}
          onRetry={retryFetch}
          retryText={t('personalCenter.myProfile.retry')}
        />
      </div>
    );
  }

  return (
    <div className="my-profile">
      <div className="profile-header">
        <h2>{t('personalCenter.myProfile.title')}</h2>
        <p>{t('personalCenter.myProfile.description')}</p>
      </div>

      <div className="profile-content">
        <div className="profile-section">
          <h3>{t('personalCenter.myProfile.avatarSettings')}</h3>
          <div className="section-content">
            <AvatarUpload 
              currentAvatar={currentUser?.avatar}
              onAvatarChange={updateAvatar}
            />
          </div>
        </div>

        <div className="profile-section">
          <h3>{t('personalCenter.myProfile.basicInformation')}</h3>
          <div className="section-content">
            <UserInfoDisplay user={currentUser} />
            <ProfileForm 
              userProfile={currentUser}
              onProfileUpdate={updateProfile}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;